<app-header-latest></app-header-latest>
<!-- HERO -->
<div class="glob-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🌐 WORLDWIDE INFRASTRUCTURE</div>
      <h1>Global HR &amp;<br>Payroll for <span style="color:#2DD4BF;">Borderless Teams</span></h1>
      <p>Hire, pay, and manage full-time employees or independent contractors across 120+ countries — in local currency and fully compliant.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#" class="btn btn-primary" style="background:#0D9488;">Start Global Hiring</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">View Supported Countries</a>
      </div>
    </div>
    <div>
      <div class="map-widget">
        <div class="map-bg-grid">
          <div class="map-pin pin-sf">San Francisco</div>
          <div class="map-pin pin-lon">London</div>
          <div class="map-pin pin-blr">Bangalore</div>
          <div class="map-pin pin-syd">Sydney</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FX CONVERSION -->
<section class="fx-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">💸 Multi-Currency Engine</span>
      <h2 class="sec-h2">Pay Locally in Seconds,<br><span class="gradient-text">Anywhere on Earth.</span></h2>
      <p class="sec-sub">Send unified disbursements and let NeoHRMZ convert exchange rates and execute direct transfers automatically.</p>
    </div>
    <div class="fx-grid">
      <div class="fx-card">
        <div class="fx-input-row">
          <div class="fx-field">
            <div class="fx-lbl">Source Currency</div>
            <select class="fx-select" disabled><option>USD — United States Dollar</option></select>
          </div>
          <div class="fx-field">
            <div class="fx-lbl">Target Currency</div>
            <select class="fx-select" disabled><option>EUR — Euro Zone</option></select>
          </div>
        </div>
        <div class="fx-lbl">Estimated Payout Amount</div>
        <div class="fx-val-preview">€8,430.00 EUR</div>
      </div>
      <div class="fx-desc-list">
        <div class="fx-desc-item">
          <div class="fx-desc-num">1</div>
          <div><div class="fx-desc-title">Localized Pay Rules</div><div class="fx-desc-text">We match local labor laws, paid holiday schedules, pension guidelines, and tax brackets automatically per jurisdiction.</div></div>
        </div>
        <div class="fx-desc-item">
          <div class="fx-desc-num">2</div>
          <div><div class="fx-desc-title">Single-Click Global Runs</div><div class="fx-desc-text">Forget separate runs for each country. Click once, process payouts across all currencies, and get a unified receipt.</div></div>
        </div>
        <div class="fx-desc-item">
          <div class="fx-desc-num">3</div>
          <div><div class="fx-desc-title">Real-Time FX Rates</div><div class="fx-desc-text">Rates are refreshed continuously so your employees always receive accurate compensation without manual recalculations.</div></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- COUNTRIES GRID -->
<section class="countries-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🗺️ 120+ Countries</span>
      <h2 class="sec-h2">Hire Anywhere,<br><span class="gradient-text">Stay Compliant Everywhere</span></h2>
      <p class="sec-sub">Built-in country-specific labor law rules, local holidays, tax withholdings, and statutory benefits.</p>
    </div>
    <div class="countries-grid">
      <div class="country-card"><div class="country-card__flag">🇺🇸</div><div class="country-card__name">United States</div></div>
      <div class="country-card"><div class="country-card__flag">🇬🇧</div><div class="country-card__name">United Kingdom</div></div>
      <div class="country-card"><div class="country-card__flag">🇩🇪</div><div class="country-card__name">Germany</div></div>
      <div class="country-card"><div class="country-card__flag">🇫🇷</div><div class="country-card__name">France</div></div>
      <div class="country-card"><div class="country-card__flag">🇮🇳</div><div class="country-card__name">India</div></div>
      <div class="country-card"><div class="country-card__flag">🇨🇦</div><div class="country-card__name">Canada</div></div>
      <div class="country-card"><div class="country-card__flag">🇦🇺</div><div class="country-card__name">Australia</div></div>
      <div class="country-card"><div class="country-card__flag">🇸🇬</div><div class="country-card__name">Singapore</div></div>
      <div class="country-card"><div class="country-card__flag">🇯🇵</div><div class="country-card__name">Japan</div></div>
      <div class="country-card"><div class="country-card__flag">🇧🇷</div><div class="country-card__name">Brazil</div></div>
      <div class="country-card"><div class="country-card__flag">🇲🇽</div><div class="country-card__name">Mexico</div></div>
      <div class="country-card"><div class="country-card__flag">🇳🇱</div><div class="country-card__name">Netherlands</div></div>
      <div class="country-card"><div class="country-card__flag">🇦🇪</div><div class="country-card__name">UAE</div></div>
      <div class="country-card"><div class="country-card__flag">🇿🇦</div><div class="country-card__name">South Africa</div></div>
      <div class="country-card"><div class="country-card__flag">🌍</div><div class="country-card__name">+106 More</div></div>
    </div>
  </div>
</section>

<!-- COMPLIANCE FEATURES -->
<section class="global-compliance">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">⚖️ Built-In Compliance</span>
      <h2 class="sec-h2">Local Laws, Handled<br><span class="gradient-text">Automatically</span></h2>
      <p class="sec-sub">Every country comes pre-loaded with statutory rules so your team never has to become a global labor law expert.</p>
    </div>
    <div class="compliance-feat-grid">
      <div class="compliance-feat-card">
        <div class="compliance-feat-card__icon">🏛️</div>
        <div class="compliance-feat-card__title">Statutory Benefits Engine</div>
        <div class="compliance-feat-card__desc">Automatic calculation of provident funds, health insurance mandates, pension contributions, and gratuity obligations per country.</div>
      </div>
      <div class="compliance-feat-card">
        <div class="compliance-feat-card__icon">📋</div>
        <div class="compliance-feat-card__title">Contract Templates Library</div>
        <div class="compliance-feat-card__desc">Jurisdiction-specific employment contract templates pre-approved for local regulatory requirements — ready to send in minutes.</div>
      </div>
      <div class="compliance-feat-card">
        <div class="compliance-feat-card__icon">🔔</div>
        <div class="compliance-feat-card__title">Regulatory Change Alerts</div>
        <div class="compliance-feat-card__desc">Our legal team monitors legislation in 120+ countries and pushes automatic updates so you're always running current rules.</div>
      </div>
      <div class="compliance-feat-card">
        <div class="compliance-feat-card__icon">🧾</div>
        <div class="compliance-feat-card__title">Multi-Country Tax Filing</div>
        <div class="compliance-feat-card__desc">Aggregate and file cross-border tax documents from a single dashboard — with full audit trails for every jurisdiction.</div>
      </div>
      <div class="compliance-feat-card">
        <div class="compliance-feat-card__icon">📅</div>
        <div class="compliance-feat-card__title">Local Holiday Calendars</div>
        <div class="compliance-feat-card__desc">Every national and regional public holiday pre-loaded and automatically reflected in payroll and leave calculations.</div>
      </div>
      <div class="compliance-feat-card">
        <div class="compliance-feat-card__icon">🔐</div>
        <div class="compliance-feat-card__title">GDPR &amp; Data Residency</div>
        <div class="compliance-feat-card__desc">Employee data stored in the correct regional data center — meeting GDPR, PDPA, and other data sovereignty requirements.</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="global-cta">
  <div class="container-wrapper">
    <h2 class="global-cta__h2">Build Your Global Team<br>Without the Complexity</h2>
    <p class="global-cta__p">Join 800+ companies managing cross-border workforces with NeoHRMZ. Start your free 30-day trial today.</p>
    <div class="global-cta__actions">
      <a href="#" class="btn btn-white">Start Global Hiring</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Talk to Our Team</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>